import React from 'react'
import { withNamespaces } from 'react-i18next'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { formatHours } from '../../helpers'

// TODO hardcoded value
const maxHours = 16

const StyledProductCard = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;

  padding: 21px 19px 18px 19px;
  background-color: #fff;
  border-radius: 4px;

  margin-bottom: 20px;

  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
`

const ProductInfo = styled.div`
  display: flex;
  align-items: center;

  color: #2e384d;
`

const StyledHoursList = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 26px;
  margin-bottom: 14px;
`

const StyledHoursItem = styled.div`
  display: flex;
  flex-direction: column;

  margin-bottom: 10px;
`

const HoursItemData = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .type {
    color: #2e384d;
  }

  .hours {
    color: #8798ad;
  }
`

const HoursItemBar = styled.div`
  width: 100%;
  height: 5px;
  position: relative;
  background-color: rgba(46, 91, 255, 0.15);
  border-radius: 4px;
  overflow: hidden;

  margin-top: 10px;

  .overflow {
    position: absolute;
    top: 0;
    left: 0;

    width: ${(props) => props.width}%;
    height: 5px;

    background-color: #2e5bff;
    border-radius: 4px;
  }
`

const StyledTransactionsButton = styled.div`
  text-align: center;
  margin-top: 27px;
  transition: opacity 0.2s;

  color: #4c84ff;

  :hover {
    text-decoration: none;
    opacity: 0.8;
  }
`

const ProductCard = ({ product, t, propertyId }) => {
  const { name, support_hours } = product

  return (
    <StyledProductCard>
      <ProductInfo>{name}</ProductInfo>
      {support_hours.length > 0 && (
        <StyledHoursList>
          {support_hours.map((s, index) => {
            const maxSupportHours = s.initial_amount || maxHours

            const width = (s.amount / maxSupportHours) * 100

            return (
              <StyledHoursItem key={index}>
                <HoursItemData>
                  <div className="type">{t(`hoursTypes:${s.type}`)}</div>
                  <div className="hours">{formatHours(s.amount)}</div>
                </HoursItemData>
                <HoursItemBar width={width}>
                  <div className="overflow" />
                </HoursItemBar>
              </StyledHoursItem>
            )
          })}

          <Link
            to={`/dashboard/transactions/${propertyId}/${product.product_id}`}
          >
            <StyledTransactionsButton>
              {t('transactions:viewTransactions')}
            </StyledTransactionsButton>
          </Link>
        </StyledHoursList>
      )}
    </StyledProductCard>
  )
}

export default withNamespaces()(ProductCard)
